import { createHistoryRouter, createRoute, createRouterControls } from 'atomic-router';
import { createBrowserHistory } from 'history';

export const gameRoute = createRoute();

export const resultRoute = createRoute<{ id: string }>();

export const controls = createRouterControls();

export const router = createHistoryRouter({
	routes: [
		{ path: '/', route: gameRoute },
		{ path: '/result', route: resultRoute },
	],
	controls,
});

router.setHistory(createBrowserHistory());
